import FavoriteButton from '../favorite/favoriteButton';
import Favorite from '../favorite/favorite';
import SearchClass from '../../lib/search/SearchClass';
import Template from '../../../lib/Template';
import {__} from '../lang/translator';

class Map {
  constructor(centerPrefecture = '', centerCity = '', permissibleInitOfficeEmpty = false) {
    /** @type {string} セレクタID */
    this.selector = 'map';
    /** @type {object} 選択中の都道府県 */
    this.center = this.concatAddress(centerPrefecture, centerCity);
    /** @type {object} 変換中心地 */
    this.centerData = {
      '東京': '千代田区',
    };
    /** @type {boolean} 初期化時に物件がない場合の許可 */
    this.permissibleInitOfficeEmpty = permissibleInitOfficeEmpty;

    /** @type {string} 検索用APIエンドポイント */
    this.ajaxSeachEndPoint = route('web.search.map.process');

    /** @type {string} セレクタID ビル合計 */
    this.pageTotalId = 'data-page-total';
    /** @type {string} セレクタID 表示開始数 */
    this.pageFromlId = 'data-page-from';
    /** @type {string} セレクタID 表示終了数 */
    this.pageTolId = 'data-page-to';
    /** @type {boolean} 検索クラス */
    this.functionSearchClass = false;

    /** @type {string} セレクタID リストアイテム */
    this.mapListID = 'data-map-list-id'

    /** @type {string} 経度緯度の検索パラメーター */
    this.latitudeFrom = 'latitude_from';
    this.latitudeTo = 'latitude_to';
    this.longitudeFrom = 'longitude_from';
    this.longitudeTo = 'longitude_to';

    // 物件一覧のテンプレート挿入要素
    this.listTemplateContainer = document.querySelector('[data-template-map-list]');
    // 物件一覧のテンプレート
    this.listTemplate = new Template(document.getElementById('result-map-list'));
    // マーカーのテンプレート
    this.markerTemplate = new Template(document.getElementById('map-marker'));
    this.markerClickedTemplate = new Template(document.getElementById('map-marker-click'));
    // 情報ウィンドウ配列
    this.infowindows = {};
  }

  /**
   * 変数の初期化
   */
  valueInit() {
    /** @type {object} map */
    this.map = {};
    /** @type {object} geocoder */
    this.geocoder = {};
    /** @type {object} マーカーリスト(オブジェクト) */
    this.markerList = null;
    /** @type {array} マーカー(配列) */
    this.markerArray = [];
    /** @type {int} マーカー数 */
    this.marker_cnt = 0;
    /** @type {int} 緯度 */
    this.latitude = 0;
    /** @type {int} 経度 */
    this.longitude = 0;
    /** @type {int} ズームレベル */
    this.zoomLevel = 15;
    /** @type {string} 中心地キーワード */
    this.mapWord = this.center;
    /** @type {string} 中心地キーワード デフォルト */
    this.mapWordDefault = "東京";
    /** @type {boolean} 地図を動かしながら再検索,表示必要有無 */
    this.movingView = false;
    /** @type {string} 地図を動かしながら再検索 name属性 */
    this.movingName = 'moving-search';
    /** @type {boolean} 地図を動かしながら再検索 */
    this.movingFlag = true;
    /** @type {boolean} 検索パラメーター */
    this.parameter = {};
    /** @type {boolean} 現在地取得 */
    this.currentLocation = false;
    /** @type {boolean} searchRequest メソッドで検索中かを判定するフラグ */
    this.reSearching = false;
    /** @type {boolean} マップの初期化中かを判定するフラグ */
    this.initializing = false;
    /** @type {boolean} マップのドラッグが行われたかを判定するフラグ */
    this.dragEnd = false;
  }

  /* ページ読み込み */
  async start() {
    const self = this;
    // 変数初期化
    self.valueInit();
    // オプション
    self.otherOption();
    // マップ展開
    await self.mapInit();
  }

  otherOption() {
    const self = this;
    // その他JS読み込み
    for (let js in self.jses) {
      self.script[js] = document.createElement("script");
      self.script[js].setAttribute("type", "text/javascript");
      self.script[js].setAttribute("src", self.jses[js]);
      self.script[js].setAttribute("async", "async");
      self.script[js].setAttribute("defer", "defer");
      document.body.appendChild(self.script[js]);
    }

    // エラー表示領域を追加
    $('#' + this.selector).parent().prepend('<p id="map_error" class="c-paragraph12"></p>');
    // ローディング領域を追加
    $('#' + this.selector).parent().css({position: 'relative'});
    $('#' + this.selector).parent().append('<div id="map_loading" style="position:absolute;top:0px;left:0px;width:100%;height:100%;background-color:rgba(0,0,0,0.3);pointer-events:none;display:none;"></div>');
  }

  async mapInit(p = {
    'zoom_level': null,
    'map_word': null
  }) {
    // マップの初期化中フラグを立てる
    this.initializing = true;

    // パラメーターセット
    this.zoomLevel = p['zoom_level'] ? p['zoom_level'] : this.zoomLevel;
    this.mapWord = p['map_word'] ? p['map_word'] : this.mapWord;
    // ライブラリ
    const {Map} = await google.maps.importLibrary("maps");
    const {AdvancedMarkerElement} = await google.maps.importLibrary("marker");
    const {LatLng} = await google.maps.importLibrary("core");
    this.libraryMap = Map;
    this.libraryAdvancedMarkerElement = AdvancedMarkerElement;
    this.libraryLatLng = LatLng;

    // this
    let self = this;

    // マップ表示
    self.map = new this.libraryMap(document.getElementById(self.selector), {
      mapId: 'map',
      zoom: self.zoomLevel,
      disableDefaultUI: true,
      center: {
        lat: self.latitude,
        lng: self.longitude
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      gestureHandling: 'cooperative',
      // マップタイプ コントロール
      mapTypeControl: true,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
      },
      // 全画面表示コントロール
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.TOP_LEFT,
      },
      // ストリートビュー コントロール
      streetViewControl: true,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      // ズーム コントロール
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      // 回転 コントロール
      rotateControl: true,
      // スケール コントロール
      scaleControl: true,
      scaleControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
    });

    // 現在地取得フラグがある場合
    if (this.currentLocation === true) {
      // 現在地取得
      if (!self.mapWord & !self.latitude & !self.longitude) {
        try {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              // "enableHighAccuracy": false ,
              "timeout": 8000,// 8秒
              // "maximumAge": 5000 ,
            });
          });
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        } catch (error) {
          console.error(error)
          self.mapWord = self.mapWordDefault
        }
      }
      // 現在地取得フラグを削除（現在地取得は初回読み込み時の為）
      this.currentLocation = false;
    } else {
      // 現在地取得フラグがない場合
      self.mapWord = self.mapWord ? self.mapWord : self.mapWordDefault;
    }

    // ジオコード
    self.geocoder = new google.maps.Geocoder();
    // ジオコード オプション
    let geoOpts = {};
    geoOpts['region'] = 'jp';
    geoOpts['address'] = typeof self.centerData[self.mapWord] != 'undefined' ? self.centerData[self.mapWord] : self.mapWord;
    geoOpts['location'] = new google.maps.LatLng(self.latitude, self.longitude);

    await self.geocoder.geocode(geoOpts,
      async (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          self.markerList = new google.maps.MVCArray();

          // 地図のドラッグイベントが終了した際に発火するイベントを付与
          google.maps.event.addListener(self.map, 'dragend', function () {
            // ドラッグイベントが終了したらフラグを立てる
            self.dragEnd = true;
          });

          // 地図の操作が終了した際に発火するイベントを付与
          google.maps.event.addListener(self.map, 'idle', function () {

            // ドラッグイベントが発生していない場合は処理を抜ける
            if (!self.dragEnd) {
              return;
            }

            // ドラッグイベントが終了したらフラグを解除
            self.dragEnd = false;

            if (self.movingFlag !== true || self.movingFlag) {
              // 現在アクティブな市区名を非アクティブに変更する
              const currentCityElement = document.querySelector('[data-current-city]');
              currentCityElement && currentCityElement.classList.remove('active');

              self.search();
            }
          });
          google.maps.event.addListener(self.map, 'zoom_changed', function () {
            if (self.movingFlag !== true || self.movingFlag) {
              self.search();
            }
          });

          self.map.setCenter(results[0].geometry.location);
          var bounds = new google.maps.LatLngBounds();
          for (var r in results) {
            if (results[r].geometry) {
              var latlng = results[r].geometry.location;
              bounds.extend(latlng);
              new google.maps.Marker({});
            }
          }

          if ($('#map_error').html()) {
            console.error('ERROR geocode')
            $('#map_error').html("").show();
          }

          await self.search();
        } else {
          $('#map_error').html(" ※入力されたキーワードからは位置情報が見つかりませんでした。").show();
        }

        // マップの初期化中フラグを解除
        this.initializing = false;
      }
    );
  }

  // 検索
  async search() {
    const self = this;

    if ($('#map_loading').is(':visible')) {
      return false;
    }

    // ローディング表示
    $('#map_loading').show();

    // 検索処理を実行
    await self.searchRequest();

    // マーカーをセット
    self.setMarker();

    // リストをセット
    self.setList();

    // ローディング非表示
    $('#map_loading').hide();
  }

  // 検索条件をパラメータにセットして API を叩く
  async searchRequest() {
    const self = this;

    const bounds = self.map.getBounds();

    self.latitude1 = bounds.getSouthWest().lat();
    self.longitude1 = bounds.getSouthWest().lng();
    self.latitude2 = bounds.getNorthEast().lat();
    self.longitude2 = bounds.getNorthEast().lng();
    self.zoomLevel = self.map.getZoom();

    // 現在の市区コードを取得
    const dataCitySearch = document.querySelector('[data-city-search].active');
    const cityCode = dataCitySearch && [dataCitySearch.getAttribute('data-city-search')]

    //マーカー初期化
    if (self.markerList !== null) {
      self.markerList.forEach(function (marker, idx) {
        marker.setMap(null);
      });
      self.markerList.clear();
    }

    // 検索項目から取得
    self.searchInput();

    // 経度緯度パラメータ設置
    self.parameter[self.latitudeFrom] = self.latitude1;
    self.parameter[self.latitudeTo] = self.latitude2;
    self.parameter[self.longitudeFrom] = self.longitude1;
    self.parameter[self.longitudeTo] = self.longitude2;
    self.parameter['mapproc_city_code'] = cityCode;

    // 地図を動かしながら再検索
    if (self.movingView === true) {
      self.changeMoving()
    }

    // 検索実行
    self.result = await self.ajax(self.parameter);

    // 初期化時に物件がない場合の許可がある場合は、検索結果が空でも再検索を行わない
    if (self.permissibleInitOfficeEmpty) {
      return;
    }

    // 同じエリアに物件が存在し、再検索中・初期化処理による検索の場合
    if (self.result?.position && !self.reSearching && self.initializing) {
      self.reSearching = true;

      // 地図の中心位置を返された物件の位置に変更し、再度検索
      self.map.setCenter(new google.maps.LatLng(self.result.position.latitude, self.result.position.longitude));
      await self.searchRequest();

      self.reSearching = false;
    }
  }

  /**
   * 検索実行
   *
   * 該当物件があればそれを返却
   * 該当物件はないが、同じエリアに物件が存在する場合はその物件の位置情報を返却
   * それ以外は空の配列を物件情報として返却
   */
  async ajax(data) {
    return await axios.get(this.ajaxSeachEndPoint, {params: data})
      .then(response => {
        // 成功
        try {
          return response.data;
        } catch (e) {
          // 失敗
          console.error(e);
        }
      }).catch(error => {
        // 失敗
        console.error(error);
      });
  }

  // 現在地取得
  currentPosition() {
    const optionObj = {
      "enableHighAccuracy": false,
      "timeout": 8000,// 8秒
      "maximumAge": 5000,
    };
    navigator.geolocation.getCurrentPosition(this.successFunc, this.errorFunc, optionObj);
  }

  // 現在地取得成功
  successFunc(position) {
    const self = this;
    this.latitude = position.coords.latitude;
    this.longitude = position.coords.longitude;
  }

  // 現在地取得失敗
  errorFunc(error) {
    // エラーコードのメッセージを定義
    const errorMessage = {
      0: "原因不明のエラーが発生しました…。",
      1: "位置情報の取得が許可されませんでした…。",
      2: "電波状況などで位置情報が取得できませんでした…。",
      3: "位置情報の取得に時間がかかり過ぎてタイムアウトしました…。",
    };
    // エラーコードに合わせたエラー内容をデバッグ
    console.error('現在地取得失敗 :', errorMessage[error.code]);
  }

  // マーカーセット
  setMarker() {
    const self = this;
    const data = self.result;

    data.offices.map(office => {
      // マーカーの座標を取得
      const coordinate = new google.maps.LatLng(office.latitude, office.longitude);

      // マーカー要素
      const markerElement = document.createElement("div");
      markerElement.id = "marker" + office.id;
      markerElement.className = "marker"
      markerElement.tabIndex = -1;
      markerElement.value = false;
      markerElement.innerHTML = this.markerTemplate.compiler({
        office: office,
        service_brand: office.service_brand
      });

      /**
       * InfoViewを生成
       */
        // ビュー要素
      const viewElement = document.createElement('div');
      viewElement.innerHTML = this.markerClickedTemplate.compiler({
        office: office
      });
      this.infowindows[office.id] = new google.maps.InfoWindow({
        content: viewElement,
      });

      // マーカーを生成
      const marker = new google.maps.marker.AdvancedMarkerElement({
        id: office.id,
        map: self.map,
        position: coordinate,
        content: markerElement,
        title: `${office.name} 位置情報`,
      });

      // マーカーのクリックイベント
      marker.addListener('gmp-click', () => {
        // マップが画面から見切れていると不自然にページが移動してしまうことが多いため、画面内に収まるようページをスクロール
        document.getElementById('map_wrap')?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });

        Object.keys(this.infowindows).map(officeId => {
          // 対象の物件の場合
          if (officeId == office.id) {
            // 情報ウィンドウを表示する
            this.infowindows[office.id].open({
              anchor: marker,
              map: self.map,
            })
          } else {
            // 情報ウィンドウを閉じる
            this.infowindows[officeId].close();
          }
        })
      });

      // マーカーを格納
      self.markerList.push(marker);
    })
  }

  // 結果リストセット
  setList() {
    const self = this;
    // データ
    const data = this.result;

    // 合計数を表示する要素をID属性から取得
    const dataPageTotalElement = document.getElementById(self.pageTotalId);
    if (dataPageTotalElement && typeof data.total != undefined) {
      // 合計数を表示
      dataPageTotalElement.innerHTML = Number(data.total).toLocaleString();
    }

    if (data.offices.length > 0) {
      // テンプレート生成
      this.listTemplate.insert(this.listTemplateContainer, {
        offices: data.offices,
        translateFunc: __
      });

      // スクロールTOPへ
      $('#map-list').scrollTop(0);

      // お気に入りボタンの初期化
      this.initBookmarkButton();

      // ページネーション
      // $('[name="map_pager"]').on('click', function () {
      //   self.parameter.page = $(this).val();
      //   self.search();
      // });

      // mapリストホバー
      $(`[${self.mapListID}]`).hover(function () {
        // ビルコード
        let fId = $(this).attr(self.mapListID);

        // 初期化フォーカス削除
        const markers = document.querySelectorAll('.marker');
        if (markers.length) {
          markers.forEach(function (element) {
            element.classList.remove('is-active')
          });
        }

        // ID取得
        let makerTarget = document.getElementById('marker' + fId);
        // マーカーがあるか確認
        if (!makerTarget) {
          return;
        }
        // アクティブ化
        makerTarget.classList.add('is-active')
        // 最前面
        let makerTargetParent = makerTarget.closest(".yNHHyP-marker-view");
        makerTargetParent.style.zIndex = 10;
        // フォーカス
        $(this).focus();
        return false;
      }, function () {//ホバー状態解除時
        // 初期化フォーカス削除
        const markers = document.querySelectorAll('.marker');
        if (markers.length) {
          markers.forEach(function (element) {
            // アクティブ化
            element.classList.remove('is-active')
            // 最背面
            let makerTargetParent = element.closest(".yNHHyP-marker-view");
            makerTargetParent.style.zIndex = 0;
          });
        }
        // フォーカス解除
        $(this).blur();
        return false;
      });

    } else {
      this.listTemplateContainer.innerHTML = `<p class="c-paragraph01">${ __('no_cases_found') }</p>`
    }
  }

  // SearchClass
  searchInput() {
    const self = this;
    // 検索クラス読み込み
    const functionSearchClass = new SearchClass();
    // map検索モード
    functionSearchClass.map = true;
    // 物件数初期表示
    // functionSearchClass.floorCount(self.parameter);
    // 一度読み込みがあれば読み込まない
    if (this.functionSearchClass == false) {
      // 読み込みフラグを格納
      this.functionSearchClass = true;
      // 検索項目Changeアクション
      functionSearchClass.formChange();
      // 検索ボタンクリック時
      self.mapSubmit();
      // リセット
      functionSearchClass.searchReset('mapReset');
      // タグ消しイベント
      window.addEventListener('search-tag-delete', () => {
        // 再検索
        self.quickSubmit();
      })
    }
  }

  // 検索ボタンクリック
  mapSubmit() {
    // 他の関数呼び出し用
    const self = this;
    // 検索クラス
    const functionSearchClass = new SearchClass();
    // 検索ボタンクリック時
    $('[name="mapSubmit"]').on('click', () => self.handleMapSubmit());

    // リセット
    $('[name="mapReset"]').on('click', function () {
      // リセット
      functionSearchClass.resetInput();
      // 入力値取得
      const queryParameter = functionSearchClass.getInput();
      // 検索パラメーター格納
      self.parameter = queryParameter
      // 再検索
      self.quickSubmit();
    });
  }

  // 地図に表示する物件の検索処理を実行
  async handleMapSubmit() {
    // 他の関数呼び出し用
    const self = this;
    // 入力値取得
    const queryParameter = new SearchClass().getInput();
    // 検索パラメーター格納
    self.parameter = queryParameter
    // 再検索
    await self.search()
  }

  // クイック検索
  quickSubmit() {
    // 他の関数呼び出し用
    let self = this;
    // 検索クラス
    const functionSearchClass = new SearchClass();
    // 入力値取得
    const queryParameter = functionSearchClass.getInput();
    // 検索パラメーター格納
    self.parameter = queryParameter

    // 再検索
    self.mapInit()
  }

  // お気に入りボタンの初期化処理
  async initBookmarkButton() {
    // お気に入りボタンを取得
    const buttons = document.querySelectorAll('[data-bookmark-button]');
    if (buttons.length == 0) return;

    // お気に入りした物件を取得
    const response = await Favorite.getOfficeIds();

    // お気に入りボタンの初期化
    buttons.forEach(button => {
      new FavoriteButton(button, response.data.data);
    });
  }

  /**
   * マップの中心位置を取得
   *
   * 日本語の場合は「都道府県名」+「市区名」
   * 英語の場合は「市区名」+ 半角スペース + 「都道府県名」
   *
   * @param {string} prefecture
   * @param {string} city
   * @returns {string}
   */
  concatAddress(prefecture, city) {
    if (APP_LOCALE === 'ja') {
      return prefecture + city;
    }

    return city + ' ' + prefecture;
  }
}

export default Map;
